import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  Button,
  Input,
  InputIcon,
  Spinner
} from '@salesforce/design-system-react';

import {
  AssetDetailsPane,
  SelectionDetailsAssetFilterPane,
  SelectionRules,
  SelectionTable
} from '../';

import './SelectionDetails.scss';

class SelectionDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.actions.updateAssetFilter({
      name: null,
      eligibleValue: null
    });

    if (this.state.selectedArm === undefined) {
      this.setState({
        selectedArm: this.props.block?.selection?.asset?.key
      });
    }
  }

  selectedAsset() {
    const assets = this.props.assets;
    if (this.state.selectedArm) {
      return assets.find(asset => asset.key === this.state.selectedArm);
    }
  }

  handleRowSelect(arm) {
    const selectedArm = arm === this.state.selectedArm ? undefined : arm;
    this.setState({ selectedArm });
  }

  hasFilter() {
    return this.props.assetFilter?.eligibleValue;
  }

  filteredAssets() {
    const { assets, assetFilter: filter } = this.props;
    const arms = this.props.block?.selection.arms;

    return assets.filter(asset => {
      // filter out name substrings if they don't match the key
      const filteredByName =
        filter.name &&
        !asset.key.toUpperCase().includes(filter.name.toUpperCase());

      // filter by eligibility based on if the matching arm has explaining to do
      const filteredByEligibility =
        filter.eligibleValue &&
        ((filter.eligibleValue === 'eligible' && arms[asset.key] !== null) ||
          (filter.eligibleValue === 'notEligible' && arms[asset.key] === null));

      if (filteredByName || filteredByEligibility) {
        // deselect the arm from the DataTable in SelectionTable if needed
        if (this.state.selectedArm === asset.key) {
          this.setState({
            selectedArm: null
          });
        }

        return false;
      }

      // filters succeeded without eliminating the asset, include it
      return true;
    });
  }

  renderSpinner() {
    return (
      <div className="tag-spinner">
        <Spinner variant="brand" />
      </div>
    );
  }

  renderFilterSearch(formatMessage) {
    return (
      <div className="selection-details-search-actions">
        <Input
          className="selection-details-filter-by-name-box"
          placeholder={formatMessage({
            id: 'components.ecs.selectionBrowser.details.search.placeholder'
          })}
          iconLeft={
            <InputIcon
              assistiveText={{
                icon: 'Search'
              }}
              name="search"
              category="utility"
            />
          }
          value={this.props.assetFilter?.['name'] || ''}
          onChange={(evt, { value }) =>
            this.props.actions.updateAssetFilter({ name: value })
          }
        />
        <Button
          className="selection-details-filter-toggle"
          iconCategory="utility"
          iconName="filterList"
          iconSize="medium"
          onClick={() => this.setState({ filterOpen: !this.state.filterOpen })}
          variant={this.hasFilter() ? 'brand' : undefined}
        />
      </div>
    );
  }

  renderFilterPane() {
    if (!this.state.filterOpen) {
      return null;
    }

    return (
      <SelectionDetailsAssetFilterPane
        actions={this.props.actions}
        onClose={() => this.setState({ filterOpen: false })}
        filter={this.props.assetFilter}
      />
    );
  }

  render() {
    if (this.props.selections.isLoading) {
      return this.renderSpinner();
    }

    const { formatMessage } = this.props.intl;
    const assets = this.filteredAssets();

    const link = (
      <a
        rel="noopener noreferrer"
        target="_blank"
        href="https://help.salesforce.com/articleView?id=mc_pb_einstein_content_selection.htm&type=5"
      >
        {formatMessage({
          id: 'components.ecs.selectionBrowser.details.helpLinkText'
        })}
      </a>
    );

    return (
      <div className="selection-details">
        <div className="selection-details-header">
          <h1>
            <FormattedMessage id="components.ecs.selectionBrowser.details.header" />
          </h1>
          <p>
            <FormattedMessage
              id="components.ecs.selectionBrowser.details.description"
              values={{ link }}
            />
          </p>
        </div>
        <div className="selection-search-bar">
          {this.renderFilterSearch(formatMessage)}
          {this.renderFilterPane()}
          <SelectionRules
            actions={this.props.actions}
            block={this.props.block}
          />
        </div>
        <div className="selection-table-and-details">
          <SelectionTable
            actions={this.props.actions}
            assets={assets}
            job={this.props.job}
            block={this.props.block}
            selectedArm={this.state.selectedArm}
            onRowSelect={this.handleRowSelect.bind(this)}
          />
          <AssetDetailsPane
            actions={this.props.actions}
            asset={this.selectedAsset()}
            attributes={this.props.attributes}
            selection={this.props.block?.selection}
          />
        </div>
      </div>
    );
  }
}

SelectionDetails.contextTypes = {
  router: PropTypes.object
};

SelectionDetails.propTypes = {
  actions: PropTypes.object,
  assets: PropTypes.array,
  assetFilter: PropTypes.object,
  attributes: PropTypes.array,
  selections: PropTypes.object,
  job: PropTypes.object,
  subscriber: PropTypes.string,
  block: PropTypes.object,
  location: PropTypes.object
};

export default injectIntl(SelectionDetails);
